export const Notifications = {
  APPROVED: "APPROVED",
  DENIED: "DENIED",
  NEEDS_UPDATES: "NEEDS_UPDATES"
};
